import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M14 9.967a3.016 3.016 0 0 0-4.163.173 2.993 2.993 0 0 0 0 4.154 3.016 3.016 0 0 0 4.163.173m-11-2.25a9 9 0 1 0 18 0 9 9 0 0 0-18 0"
    }, null, -1)
  ])))
}
export default { render: render }